;(function () {
    'use strict'

    var root
    var isNode
    if (typeof module !== 'undefined' && module.exports) {
        isNode = true
        root = global
    } else {
        isNode = false
        root = window
    }

    function Locale(Device, embedMessageContent, currentMessage) {
        this.currentMessage = currentMessage;
        this.device = Device;
        this.embedMessageContent = embedMessageContent;
    }

    Locale.prototype.text = function (phrase) {
        const threeRadical = (((((this.currentMessage || {}).quantities || {}).link || {}).data || {}).externalPackage || {}).threeRadical
      
        const language = this.device.language || window.navigator.userLanguage || window.navigator.language

        let translation = threeRadical && threeRadical.language && threeRadical.language.translations && (threeRadical.language.translations[phrase][language])
        
        if(!translation && language && threeRadical && threeRadical.language && threeRadical.language.translations) {
            let languageKey = language.split("-")[0]
           for (let tr in threeRadical.language.translations[phrase]){
               let trKey = tr.split("-")[0]
               if(languageKey === trKey){
                   translation = threeRadical.language.translations[phrase][tr]
               }
               
           } 
        }

        var value = (translation || (threeRadical ? threeRadical.language.phrases[phrase] : undefined));

        if (typeof value == "string") {
            value = this.embedMessageContent(value);
        }

        return value;
    }

    Locale.prototype.copy = function (phrase) {

        if(typeof phrase !== 'object'){
            return phrase
        }

        let embedMessageContent = this.embedMessageContent;
        
        const threeRadical = (((((this.currentMessage || {}).quantities || {}).link || {}).data || {}).externalPackage || {}).threeRadical
      
        const language = this.device.language || window.navigator.userLanguage || window.navigator.language

        let translation = phrase && phrase[language] ? phrase[language] : undefined
        
        if(!translation && language){
            let languageKey = language.split("-")[0]
            for(let tr in phrase){
                let trKey = tr.split("-")[0]
                if(languageKey === trKey){
                    translation = phrase[tr]
                }
            }
        }
        
        return (embedMessageContent(translation) ||  (threeRadical && threeRadical.language && threeRadical.language.default ? embedMessageContent(phrase[threeRadical.language.default]) : embedMessageContent(phrase['en-US'])))
    }
    
    const locale = (Device, embedMessageContent, currentMessage) => {
        return new Locale(Device, embedMessageContent, currentMessage);
    }
    
    function factory(Device, embedMessageContent, message) {
        return locale(Device, embedMessageContent, message)      
    }
    
    factory._depends = {
        symbol : "3r/chi/factories/locale",
        modules : [
            "3r/Device",
            "3r/message-api/content/embedMessageContent",
        ]
    }

    if (isNode) {
        module.exports = {
            locale: locale,
            factory : factory
        }
    } else {
        root.Locale = locale
    }
})()
